<button class="btn btn-primary view-changelog-btn" (click)='onClick()' [disabled]="isDisabled">
  View change log
</button>